import { render, staticRenderFns } from "./outOrdP.vue?vue&type=template&id=6b12904f&scoped=true"
import script from "./outOrdP.vue?vue&type=script&lang=js"
export * from "./outOrdP.vue?vue&type=script&lang=js"
import style0 from "./outOrdP.vue?vue&type=style&index=0&id=6b12904f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12904f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b12904f')) {
      api.createRecord('6b12904f', component.options)
    } else {
      api.reload('6b12904f', component.options)
    }
    module.hot.accept("./outOrdP.vue?vue&type=template&id=6b12904f&scoped=true", function () {
      api.rerender('6b12904f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/outOrdP.vue"
export default component.exports